// WhenPhase
// Features:
// - Declarative phase gate (conditional rendering based on current app phase)
// - Supports inclusion and exclusion lists

import { usePhase } from '../store/usePhase'

export default function WhenPhase({ includes, excludes, children }) {
    const phase = usePhase((s) => s.phase)

    const isIncluded = !includes || includes.includes(phase)
    const isExcluded = excludes && excludes.includes(phase)

    if (!isIncluded || isExcluded) return null

    return children
}
